import React from 'react'

export default function Lock (props) {
  return (
    <svg viewBox='0 0 64 64' width={props.width || 200} height={props.height || 200}>
      <path fill={props.color || '#444444'} d='M55,31.9h-5v-14h0C50,8,41.9,0,32,0S14,8,14,17.9h0v14H9c-1.1,0-2,0.9-2,2v28c0,1.1,0.9,2,2,2H55c1.1,0,2-0.9,2-2v-28C57,32.8,56.1,31.9,55,31.9z M21,17.9C21,17.9,21,17.9,21,17.9C21,11.9,26,7,32,7s11,4.9,11,10.9c0,0,0,0,0-0.1v14H21V17.9z M35.8,53h-7.5l2.4-7.1c-1.5-0.6-2.7-2-2.7-3.7c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,1.7-1.1,3.2-2.7,3.7L35.8,53z' />
      <circle fill={props.color || '#00D8A0'} cx='31.5' cy='42.1' r='4.7' />
    </svg>
  )
}
